import React from 'react';
import styled from 'styled-components';

const RightContainer = styled.div`
  position: relative;
  padding-left: 30px;
`;

export default RightContainer;
